import { ContextMenuItemView, EventContextMenuClickParams } from '@mark43/cad-api';
import { MenuItem } from '../../context-menus/components/menu-item';

export function CopyAndScheduleEventMenuItem({
    contextMenuItemView,
}: {
    clickParams: EventContextMenuClickParams;
    contextMenuItemView: ContextMenuItemView;
}): React.ReactElement {
    const handleSelect = (): void => {};
    return <MenuItem contextMenuItemView={contextMenuItemView} onSelect={handleSelect} />;
}
